@if(loading) {
<div class="cc1 scc1">
    <div class="cc2">
        <div class="cc3 skeleton"></div>
    </div>
    <div class="cc4">
        <div class="cc5">
            <div class="cc9">
                <div class="cc6 scc6 skeleton"></div>
                <div class="cc8">
                    <div class="scc8 skeleton"></div>
                </div>
            </div>
            <div class="cc7 scc7 skeleton"></div>
        </div>
        <div class="scc11 cc11">
            <div class="cc12 scc12 skeleton"></div>
            <div class="prcgw sprcgw">
                <span multilang class="abpp sabpp">
                    <div class="ss skeleton"></div>
                </span>
                <span multilang class="prcw sprcw">
                    <div class="ss skeleton"></div>
                </span>
                <span multilang class="pp spp">
                    <div class="ss skeleton"></div>
                </span>
            </div>
        </div>
    </div>
</div>
} @else {
@switch (item?.inputData?.realparams?.pauschalreiseResult?.type) {
@case (1) {
<ng-container *ngTemplateOutlet="hotelmode"></ng-container>
} @default {
<ng-container *ngTemplateOutlet="regionmode"></ng-container>
}
}
}

<ng-template #hotelmode>
    <div class="cc1">
        <div class="cc2">
            <img class="cc3"
                src="{{image?.length > 0 ? (image | cacheResource) : '../../../../assets/images/empty.jpg'}}"
                class="lazyload cc3" alt="{{hotel?.name}}">
        </div>
        <div class="cc4">
            @if(item.customtext) {
            <div class="tcc1" [style.margin-top]="item?.text?.style?.marginTop">
                <div class="tcc2 clevertextcontent" [style.max-width]="item?.text?.style?.width"
                    [style.height]="item?.text?.style?.height?.length > 0 ? item?.text?.style.height : '100%'"
                    [style.background-image]="item?.text?.style?.bgimage?.length > 0 ? 'url(' + (item?.text?.style?.bgimage | tohttps) + ')' : ''"
                    [style.background-color]="item?.text?.style?.rgbaCol" [style.padding]="item?.text?.style?.padding"
                    [ngStyle]="item?.text?.style?.styles" [ngClass]="item?.text?.style?.classes" multilang
                    deeplMode='html' [innerHtml]="item?.text?.text | cleverfragment | safehtml">
                </div>
            </div>
            } @else {
            <div class="cc5">
                <div class="cc9">
                    <span multilang class="cc6 ellipsis">{{hotel?.name}}</span>
                    <div class="cc8">
                        @for (cat of categoryAr; track $index) {
                        <mat-icon class="cc10">{{cat === 1 ? 'star': 'star_half'}}</mat-icon>
                        }
                    </div>
                </div>
                <span multilang class="cc7">{{hotel?.location?.name}}, {{hotel?.location?.region?.name}}</span>
            </div>
            <div class="cc11">
                <span multilang class="cc12">{{dauer}} {{hotel?.offerList[0].boardType?.name}}</span>
                <div class="prcwrapper">
                    @if(higherPrice) {
                    <div class="flexdiv">
                        <div class="prctext">
                            <span multilang>ab {{higherPrice | number}} p.P.</span>
                            <mat-icon class="prci" (click)="fixinfo=true; $event.stopPropagation()"
                                (mouseover)="fixinfo=true" (mouseleave)="fixinfo=false" #triggerinfo="cdkOverlayOrigin"
                                cdkOverlayOrigin fontIcon="info">
                            </mat-icon>
                        </div>
                        <span multilang class="purcw">
                            &minus; {{higherPricePr}} %
                        </span>
                    </div>
                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerinfo"
                        [cdkConnectedOverlayOpen]="fixinfo">
                        <div class="cc17infos mat-elevation-z1">
                            <b>Ihr Angebotspreis ist {{ higherPrice - curprice }} € günstiger!</b><br><br>
                            Ihr Reisepreis ist niedriger als der dritthöchste Preis, den Kunden für dasselbe Angebot
                            bereits gesehen haben.
                            Kurz gesagt: Ihr Reiseangebot ist besonders preiswert! <br><br>

                            <b>Wichtige Informationen zum Reisepreis und möglichen Abweichungen:</b><br><br>
                            Der angegebene Reisepreis unterliegt täglichen Schwankungen. Daher kann es bei der
                            letzten Preisprüfung vor der
                            Buchung zu kurzfristigen Preisänderungen durch den Veranstalter kommen.
                        </div>
                    </ng-template>
                    }
                    <div class="prcgw">
                        <span multilang class="abpp">{{'ab' }}</span>
                        <span multilang class="prcw"
                            [style.color]="higherPrice ? 'var(--cl-bg-color)' : '' ">{{hotel?.bestPricePerPerson?.value
                            | number}} €</span>
                        <span multilang class="pp">p.P.</span>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>

<ng-template #regionmode>
    <div class="cc1">
        <div class="cc2">
            <img class="cc3" [src]="image?.length > 0 ? image : '../../../../assets/images/empty.jpg'">
        </div>
        <div class="cc4">
            @if(item.customtext) {
            <div class="tcc1" [style.margin-top]="item?.text?.style?.marginTop">
                <div class="tcc2 clevertextcontent" [style.max-width]="item?.text?.style?.width"
                    [style.height]="item?.text?.style?.height?.length > 0 ? item?.text?.style.height : '100%'"
                    [style.background-image]="item?.text?.style?.bgimage?.length > 0 ? 'url(' + (item?.text?.style?.bgimage | tohttps) + ')' : ''"
                    [style.background-color]="item?.text?.style?.rgbaCol" [style.padding]="item?.text?.style?.padding"
                    [ngStyle]="item?.text?.style?.styles" [ngClass]="item?.text?.style?.classes" multilang
                    deeplMode='html' [innerHtml]="item?.text?.text | cleverfragment | safehtml">
                </div>
            </div>
            } @else {
            <div class="cc5">
                <div class="cc9">
                    <span multilang
                        class="cc6 ellipsis">{{item?.inputData?.realparams?.pauschalreiseResult?.data?.name}}</span>
                </div>
                <span multilang class="cc7">
                    @switch (item?.inputData?.realparams?.pauschalreiseResult?.type) {
                    @case (4) {
                    Land
                    } @default {
                    Region in {{item?.inputData?.realparams?.pauschalreiseResult?.data?.region?.name}}
                    }
                    }
                </span>
            </div>
            <div class="cc11">
                <span multilang class="cc12"><span multilang class="cc12">{{dauer}}
                        {{hotel?.offerList[0].boardType?.name}}</span></span>
                <div class="prcwrapper">
                    <div class="prcgw">
                        <span multilang class="abpp">{{'ab' }}</span>
                        <span multilang class="prcw">{{hotel?.bestPricePerPerson?.value
                            | number}} €</span>
                        <span multilang class="pp">p.P.</span>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>